import {RequiredDateRange} from "@/components/datetime/utils.ts";
import {StandardDateRange} from "@/lib/queries/reports.ts";
import {DownloadExport} from "@/pages/alerting/components/list/alertsControlBar/DownloadExport.tsx";
import {UserDateRangePicker} from "@/pages/alerting/components/list/alertsControlBar/UserDateRangePicker.tsx";

interface AlertActionBarProps {
  visibleRange: RequiredDateRange;
  fixedRange?: StandardDateRange;
  onVisibleRangeChange: (visibleRange: RequiredDateRange | null, fixedRange?: StandardDateRange | null) => void;
}

export const AlertActionBar = ({visibleRange, fixedRange, onVisibleRangeChange}: AlertActionBarProps) => {
  return (
    <div className="d-flex gap-2">
      <UserDateRangePicker
        range={visibleRange}
        fixedRange={fixedRange}
        onChange={onVisibleRangeChange}
        size={"large"}
        maxRange={730}
      />
      <DownloadExport range={visibleRange} />
    </div>
  );
};
